import APIClient from '@/shared/http/clients/api'

const resourceName = 'saldo-medio-captacao'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name AverageFundingBalanceRepository
 * @description Saldo médio captação
 * @type { Respository }
 */
const AverageFundingBalanceRepository = {
  Search
}

export default AverageFundingBalanceRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/averagefundingbalance.js